import { arrayToDistinct } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { AutoComplete, Form } from "antd";
import React, { useMemo } from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  const options = useMemo(() => {
    if (!props.items) return [];

    const categories = props.items
      .filter((item) => item.category)
      .map((item) => ({ value: item.category }));

    return arrayToDistinct(categories, (obj) => obj.value);
  }, [props.items]);

  return (
    <Form.Item
      label={t("maintenance:items.create.form.category.label")}
      name="category"
      initialValue={props.editItem?.category}
    >
      <AutoComplete options={options} filterOption />
    </Form.Item>
  );
};
